export default __webpack_public_path__ + "static/media/p2_page1_2.4bc32288.png";